import * as Home from './Home';

export default {  Home }; 
